/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedChevronsDown = createReactComponent(
  "square-rounded-chevrons-down",
  "IconSquareRoundedChevronsDown",
  [
    ["path", { d: "M15 9l-3 3l-3 -3", key: "svg-0" }],
    ["path", { d: "M15 13l-3 3l-3 -3", key: "svg-1" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareRoundedChevronsDown as default };
//# sourceMappingURL=IconSquareRoundedChevronsDown.js.map
